import React, { useState, useRef, useEffect } from 'react';
import { useProduct } from '../../../context/productContext/ProductContextProvider';
import { Button, Input } from '../../../components';

const UpdateProductImage = ({ closeModal, data }) => {
  const { updateProductImage, error, setError } = useProduct();
  const [imageFile, setImageFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(data?.productImage || '');
  const [showPreview, setShowPreview] = useState(false);
  const [imagePath, setImagePath] = useState(data?.itemImage || '');
  const fileInputRef = useRef(null);
  const previewRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (previewRef.current && !previewRef.current.contains(event.target)) {
        setShowPreview(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [previewRef]);

  useEffect(() => {
    if (data) {
      setLogoPreview(data.productImage || '');
      setImagePath(data.itemImage || '');
    }
  }, [data]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/avif'];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (file && !allowedTypes.includes(file.type)) {
       setError((prev) => ({ ...prev, file: 'Invalid file type. Only .jpg, .jpeg, .png, and .avif files are allowed.' }));
      if(fileInputRef.current) fileInputRef.current.value = null;
    } else if (file && file.size > maxSize) {
       setError((prev) => ({ ...prev, file: 'File size should not exceed 5MB' }));
      if(fileInputRef.current) fileInputRef.current.value = null;
    } else {
      setError((prev) => ({ ...prev, file: null }));
      setImageFile(file);
      setLogoPreview(URL.createObjectURL(file));
      setImagePath(file.name);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (data?.id && imageFile) {
      await updateProductImage(data.id, imageFile);
      closeModal();
    } else if (!imageFile) {
        setError((prev) => ({ ...prev, file: "* Please select an image file to upload." }));
    }
  };

  return (
    <form onSubmit={handleSubmit} className="p-4 w-[500px]">
      <div className="mb-4">
          <Input
            ref={fileInputRef}
            id="fileInput"
            label="Upload Image"
            type="file"
            accept=".jpg,.png,.jpeg,.avif"
            onChange={handleFileChange}
            error={error?.file}
            multiple={false}
          />
      </div>
      <div className="pt-2 relative mb-4">
          {imagePath && (
            <div className="mb-2 text-gray-500 text-sm">{imagePath}</div>
          )}
          {logoPreview && (
            <>
              <span
                className="text-blue-500 cursor-pointer"
                onClick={() => setShowPreview(true)}>
                Preview Image
              </span>
              {showPreview && (
                <div className="fixed inset-0 z-10 flex items-center justify-center bg-opacity-50 bg-black">
                   
                  <div
                    ref={previewRef}
                    className="p-4 rounded-lg bg-white shadow-lg">
                     <p className='text-end cursor-pointer ' onClick={()=>setShowPreview(false)}>X</p>
                    <img
                      src={logoPreview}
                      alt="Product Logo"
                      className=" h-96 object-cover"
                    />
                  </div>
                </div>
              )}
            </>
          )}
      </div>

      <div className="flex justify-start gap-2 mt-4">
        <Button type="button" className="secondary" onClick={closeModal}>
          Cancel
        </Button>
        <Button
          type="submit"
          className="px-4 py-2 bg-yellow-500 text-white rounded-3xl">
          Upload Image
        </Button>
      </div>
    </form>
  );
};

export default UpdateProductImage;
